module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/team/brooklyn-bungard-438d5558b7b9b9ecb19b202c3d3b0397.jpg";